"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _http = require("@/config/http");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BaseService = /*#__PURE__*/function () {
  function BaseService(resource) {
    _classCallCheck(this, BaseService);
    this.http = _http.http;
    this.resource = resource;
  }
  return _createClass(BaseService, [{
    key: "get",
    value: function get(params, config) {
      var request = this.resource;
      var options;
      if (typeof params === 'string' || typeof params === 'number') {
        // Ex. GET /resource/featured
        request = "".concat(this.resource, "/").concat(params);
        options = config;
      } else {
        // Ex. GET /resource?featured=1&active=1
        options = {
          params: params
        };
      }
      return _http.http.get(request, options);
    }
  }, {
    key: "patch",
    value: function patch(body, route) {
      var resource = this.resource;
      if (_lodash.default.isEmpty(route) === false) {
        resource = "".concat(this.resource, "/").concat(route);
      }
      return _http.http.patch(resource, body);
    }
  }, {
    key: "post",
    value: function post(body, route, config) {
      var resource = this.resource;
      if (_lodash.default.isEmpty(route) === false) {
        resource = "".concat(this.resource, "/").concat(route);
      }
      return _http.http.post(resource, body, config);
    }
  }, {
    key: "put",
    value: function put(body, route, config) {
      var resource = this.resource;
      if (_lodash.default.isEmpty(route) === false) {
        resource = "".concat(this.resource, "/").concat(route);
      }
      return _http.http.put(resource, body, config);
    }
  }, {
    key: "delete",
    value: function _delete(params) {
      var request = this.resource;
      var options;
      if (typeof params === 'string') {
        // Ex. DELETE /resource/featured
        request = "".concat(this.resource, "/").concat(params);
      } else {
        // Ex. DELETE /resource?featured=1&active=1
        options = {
          params: params
        };
      }
      return _http.http.delete(request, options);
    }
  }]);
}();
var _default = exports.default = BaseService;